import React from 'react';
import { twMerge } from 'tailwind-merge';
import useAppContext from 'flow/hooks/useAppContext';

interface Props {
    stages: number;
    currentStage: number;
    handleSelect: (strategy: number) => void;
    selectedColor: string;
}

const StageProgress = ({
    stages,
    currentStage,
    handleSelect,
    selectedColor,
}: Props) => {
    const { i18next } = useAppContext();

    return (
        <div className="flex gap-2">
            {Array.from({ length: stages }, (_, i) => i).map((index) => (
                <button
                    key={`stage-progress-${index}`}
                    aria-label={i18next.t('guide.go_to_step', {
                        number: index + 1,
                    })}
                    className={twMerge(
                        'flex size-2 cursor-pointer items-center justify-center rounded bg-gray-300',
                        currentStage === index && selectedColor,
                    )}
                    onClick={() => handleSelect(index)}
                />
            ))}
        </div>
    );
};

export default StageProgress;
